var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProfileIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.0843 5.70457C16.0843 8.84067 13.4978 11.3857 10.3089 11.3857C7.12011 11.3857 4.5336 8.84067 4.5336 5.70457C4.5336 2.56848 7.12011 0.0234375 10.3089 0.0234375C13.4978 0.0234375 16.0843 2.56848 16.0843 5.70457ZM0.0234375 19.0667C0.0234375 15.5503 2.92002 12.7003 6.49543 12.7003H14.1224C17.6978 12.7003 20.5944 15.5503 20.5944 19.0667C20.5944 19.723 20.0535 20.2595 19.3816 20.2595H1.23627C0.568247 20.2595 0.0234375 19.7268 0.0234375 19.0667Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.046875
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileIcon);
export default __webpack_public_path__ + "static/media/profileIcon.568de52b35ab5651ac5b3e64c086055a.svg";
export { ForwardRef as ReactComponent };